module.exports = __webpack_public_path__ + "media/images/partners/bebras-card-821e7a82e565f06e2012e9bbc23916ac.svg";